import { makePaginationState, STATUSES } from 'app/utils/redux';

import * as t from './types';


const initialState = {
  stories: makePaginationState(),
  tagId: null,
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch stories
    case `${t.FETCH_STORIES}_PENDING`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_STORIES}_SUCCESS`: {
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.stories.pagination.items
              .concat(action.payload.result.items),
          },
        },
      };
    }
    case `${t.FETCH_STORIES}_ERROR`:
      return {
        ...state,
        stories: {
          ...state.stories,
          status: STATUSES.ERROR,
        },
      };

    case t.RESET:
      return {
        ...state,
        stories: makePaginationState(),
        tagId: null,
      };

    case t.SET_TAG_ID:
      return {
        ...state,
        tagId: action.id,
      };

    default:
      return { ...state };
  }
};



// WEBPACK FOOTER //
// ./src/app/redux/front/tagDetail/reducer.js